import { CommandPaletteResult, CommandPaletteResultGroup } from "../types";
import { PatientResultItem } from "@/features/patient";
import { ReactNode } from "react";

interface CommandPaletteGroupProps {
  group: CommandPaletteResultGroup["group"];
  items: CommandPaletteResult[];
  flatResults: CommandPaletteResult[];
  onSelect: (result: CommandPaletteResult) => void;
  children?: ReactNode;
}

export function CommandPaletteGroup({
  group,
  items,
  flatResults,
  onSelect,
  children,
}: CommandPaletteGroupProps) {
  return (
    <div>
      <div className="px-5 pt-2.5 pb-1.5">
        <span className="text-typography-tertiary typo-label-bold-md uppercase">
          {group}
        </span>
      </div>
      {children}
      {items.map((item) => {
        if (item.kind === "patient" && item.patient) {
          return (
            <PatientResultItem
              key={item.id}
              patient={item.patient}
              cardInfo={item.patient.cardOnFile ?? null}
              onSelect={() => onSelect(item)}
              flatResults={flatResults}
            />
          );
        }
        return null;
      })}
    </div>
  );
}
